interface RestartVideoIconProps extends React.ComponentPropsWithRef<'svg'> {
  color?: string;
}

export function RestartVideoIcon({ color = 'currentColor', ...props }: RestartVideoIconProps) {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11 7.11905H12.5C16.0899 7.11905 19 10.1145 19 13.8095C19 17.5046 16.0899 20.5 12.5 20.5C8.91015 20.5 6 17.5046 6 13.8095"
        stroke={color}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9398 10.2861L8.85156 7.11947L11.9398 3.9528"
        stroke={color}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
